var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_289087154276331217029762830496344647849",
    d: "M12.105 2.224h-.753c-.062 0-.119-.035-.147-.09l-.005-.012-.458-.865c-.21-.412-.625-.668-1.087-.668H6.789c-.462 0-.878.256-1.087.668l-.458.865-.005.011c-.028.056-.085.091-.147.091H3.958v-.527H1.822v.527H1.77c-.873 0-1.583.71-1.583 1.582v7.383c0 .872.71 1.582 1.583 1.582h10.335c.873 0 1.582-.71 1.582-1.582V3.806c0-.872-.71-1.582-1.582-1.582zm.528 8.965c0 .29-.237.527-.528.527H1.77c-.291 0-.528-.236-.528-.527V3.806c0-.29.237-.527.528-.527h1.107v7.383h1.055V3.279h1.16c.462 0 .878-.256 1.087-.668l.458-.865.006-.011c.027-.056.084-.091.146-.091h2.866c.062 0 .118.035.146.09l.006.012.458.865c.209.412.625.668 1.087.668h.753c.291 0 .528.236.528.527v7.383zm-4.35-7.067c-1.745 0-3.165 1.42-3.165 3.165 0 1.744 1.42 3.164 3.164 3.164 1.745 0 3.164-1.42 3.164-3.164 0-1.745-1.42-3.165-3.164-3.165zm0 5.274c-1.164 0-2.11-.946-2.11-2.11 0-1.163.946-2.109 2.11-2.109 1.162 0 2.109.946 2.109 2.11 0 1.163-.947 2.109-2.11 2.109z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.063 1.66)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_82071036458631053146751405754864704737",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_289087154276331217029762830496344647849"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_289087154276331217029762830496344647849"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#hinava_random_uuid_82071036458631053146751405754864704737)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130.781,
    height: 59.304,
    rx: 8,
    transform: "translate(-57.75 -24)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.6fdedc0d228b8a0d3644da59ea51baea.svg";
export { ForwardRef as ReactComponent };